import React, { useEffect, useState } from "react";
import "./ItemInfoModal.css";
import { Modal } from "@mui/material";

import { arrowLeftWhite } from "../../../../Assets/svgs";
import { formatDateTime } from "../../../../Utils/TimeConverter";

interface InfoModalInterface {
  children: React.ReactElement;
  image: string;
  title: string;
  description: string;
  isVisible: boolean;
  currentItemId: number;
  onClose: () => void;
  cbHandleCloseItemInfo: () => void;
  cbAddRecommended: (currentItemId: number) => void;
  examDate: string;
}

const ItemInfoModal = (props: InfoModalInterface) => {
  console.log(props);
  useEffect(() => {
    const handleBeforeUnload = () => {
      props.cbHandleCloseItemInfo();
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      props.cbHandleCloseItemInfo();
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <Modal
      style={{
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
      }}
      open={props.isVisible}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="item-info-wrap">
        <button
          className="item-info-back-button"
          onClick={props.cbHandleCloseItemInfo}
        >
          <img
            style={{
              top: "-5px",
            }}
            src={arrowLeftWhite}
            alt="&lt;-"
          />
          Go back
        </button>
        <br />
        <div className="item-info-container">
          <img className="item-info-image" alt="info-image" src={props.image} />
          <div className="item-info-title">{props.title}</div>
          <div className="item-info-desc">
            The National Finance Olympiad is a competitive exam focused on
            building financial literacy among students across India. <br />
            <br />
            What's included with your registration?
            <div style={{ margin: "10px 10px", paddingLeft: "10px" }}>
              <ul>
                <li>Access to study material and a sample question paper</li>
                <li>Certificates for all participants</li>
                <li>The opportunity to compete with top students nationwide</li>
                <li>A chance to win ₹4 Lakhs+ in scholarships</li>
              </ul>
            </div>
            The Olympiad can be attempted with a laptop/desktop from the comfort
            of your home.
          </div>
          <div className="item-info-date-container">
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className="item-info-date-title">Exam Date : </div>
              <div className="item-info-date-value">
                {formatDateTime(props.examDate).split(",")[0]}
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className="item-info-date-title">Exam Time : </div>
              <div className="item-info-date-value">
                {formatDateTime(props.examDate).split(",")[1].trim()}
              </div>
            </div>
          </div>
          <div className="item-info-additembutton">
            <button
              className="item-info-overlap"
              onClick={() => {
                props.cbHandleCloseItemInfo();
                props.cbAddRecommended(props.currentItemId);
              }}
            >
              <div className="item-info-text-wrapper-7">Add to Cart</div>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ItemInfoModal;
